import { render, staticRenderFns } from "./TextFloating.vue?vue&type=template&id=15a9ca5e"
import script from "./TextFloating.vue?vue&type=script&lang=ts"
export * from "./TextFloating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports